export const STORAGE_KEYS = {
	FAVORITES: "FAVORITES",
} as const;

export type STORAGE_KEYS_TYPE =
	(typeof STORAGE_KEYS)[keyof typeof STORAGE_KEYS];

const PREDEFINE_HOST = "FLUXBEAM";

export const storage = {
	get: <T>(key: STORAGE_KEYS_TYPE, defaultValue: T): T => {
		const value = localStorage.getItem(
			`${PREDEFINE_HOST}::${STORAGE_KEYS[key]}`
		);
		if (value === null) return defaultValue;
		try {
			return typeof defaultValue === "number"
				? (Number(value) as unknown as T)
				: (value as unknown as T);
		} catch {
			return defaultValue;
		}
	},
	set: (key: STORAGE_KEYS_TYPE, value: string | number): void => {
		localStorage.setItem(
			`${PREDEFINE_HOST}::${STORAGE_KEYS[key]}`,
			String(value)
		);
	},
	del: (key: STORAGE_KEYS_TYPE): void => {
		localStorage.removeItem(`${PREDEFINE_HOST}::${STORAGE_KEYS[key]}`);
	},
	clear: (): void => localStorage.clear(),
};
